function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("title", null, "noun_Wallet_1073181 (1)");

var _ref2 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref3 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "noun_Wallet_1073181-(1)",
  fillRule: "nonzero"
}, React.createElement("path", {
  d: "M69.6,18.3 L69,18.3 L69,6.4 C69,3.4 66.6,0.9 63.5,0.9 L5.6,0.9 C2.6,0.9 0.1,3.3 0.1,6.4 L0.1,48 C0.1,51 2.5,53.5 5.6,53.5 L63.5,53.5 C66.5,53.5 69,51.1 69,48 L69,35.1 L69.6,35.1 C71.3,35.1 72.7,33.7 72.7,32 L72.7,21.4 C72.7,19.7 71.3,18.3 69.6,18.3 Z M66.9,48 C66.9,49.9 65.4,51.5 63.4,51.5 L5.6,51.5 C3.7,51.5 2.1,50 2.1,48 L2.1,6.4 C2.1,4.5 3.6,2.9 5.6,2.9 L63.5,2.9 C65.4,2.9 67,4.4 67,6.4 L67,18.3 L45.6,18.3 C43.9,18.3 42.5,19.7 42.5,21.4 L42.5,31.9 C42.5,33.6 43.9,35 45.6,35 L66.9,35 L66.9,48 Z M70.7,31.9 C70.7,32.5 70.2,33 69.6,33 L45.6,33 C45,33 44.5,32.5 44.5,31.9 L44.5,21.4 C44.5,20.8 45,20.3 45.6,20.3 L69.6,20.3 C70.2,20.3 70.7,20.8 70.7,21.4 L70.7,31.9 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M51.1,23 C49.1,23 47.4,24.6 47.4,26.7 C47.4,28.8 49,30.4 51.1,30.4 C53.2,30.4 54.8,28.8 54.8,26.7 C54.8,24.6 53.1,23 51.1,23 Z M51.1,28.3 C50.2,28.3 49.4,27.6 49.4,26.6 C49.4,25.6 50.1,24.9 51.1,24.9 C52.1,24.9 52.8,25.6 52.8,26.6 C52.8,27.6 52,28.3 51.1,28.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M8.9,6.3 L6.4,6.3 C5.8,6.3 5.4,6.7 5.4,7.3 C5.4,7.9 5.8,8.3 6.4,8.3 L8.9,8.3 C9.5,8.3 9.9,7.9 9.9,7.3 C9.9,6.7 9.4,6.3 8.9,6.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M15.5,6.3 L13,6.3 C12.4,6.3 12,6.7 12,7.3 C12,7.9 12.4,8.3 13,8.3 L15.5,8.3 C16.1,8.3 16.5,7.9 16.5,7.3 C16.5,6.7 16.1,6.3 15.5,6.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M22.2,6.3 L19.7,6.3 C19.1,6.3 18.7,6.7 18.7,7.3 C18.7,7.9 19.1,8.3 19.7,8.3 L22.2,8.3 C22.8,8.3 23.2,7.9 23.2,7.3 C23.2,6.7 22.8,6.3 22.2,6.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M28.9,6.3 L26.4,6.3 C25.8,6.3 25.4,6.7 25.4,7.3 C25.4,7.9 25.8,8.3 26.4,8.3 L28.9,8.3 C29.5,8.3 29.9,7.9 29.9,7.3 C29.9,6.7 29.4,6.3 28.9,6.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M35.6,6.3 L33,6.3 C32.4,6.3 32,6.7 32,7.3 C32,7.9 32.4,8.3 33,8.3 L35.5,8.3 C36.1,8.3 36.5,7.9 36.5,7.3 C36.5,6.7 36.1,6.3 35.6,6.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M39.7,8.3 L42.2,8.3 C42.8,8.3 43.2,7.9 43.2,7.3 C43.2,6.7 42.8,6.3 42.2,6.3 L39.7,6.3 C39.1,6.3 38.7,6.7 38.7,7.3 C38.7,7.9 39.2,8.3 39.7,8.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M46.4,8.3 L48.9,8.3 C49.5,8.3 49.9,7.9 49.9,7.3 C49.9,6.7 49.5,6.3 48.9,6.3 L46.4,6.3 C45.8,6.3 45.4,6.7 45.4,7.3 C45.4,7.9 45.9,8.3 46.4,8.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M53.1,8.3 L55.6,8.3 C56.2,8.3 56.6,7.9 56.6,7.3 C56.6,6.7 56.2,6.3 55.6,6.3 L53.1,6.3 C52.5,6.3 52.1,6.7 52.1,7.3 C52.1,7.9 52.5,8.3 53.1,8.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M59.8,8.3 L62.3,8.3 C62.9,8.3 63.3,7.9 63.3,7.3 C63.3,6.7 62.9,6.3 62.3,6.3 L59.8,6.3 C59.2,6.3 58.8,6.7 58.8,7.3 C58.8,7.9 59.2,8.3 59.8,8.3 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M8.9,45.6 L6.4,45.6 C5.8,45.6 5.4,46 5.4,46.6 C5.4,47.2 5.8,47.6 6.4,47.6 L8.9,47.6 C9.5,47.6 9.9,47.2 9.9,46.6 C9.9,46 9.4,45.6 8.9,45.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M15.5,45.6 L13,45.6 C12.4,45.6 12,46 12,46.6 C12,47.2 12.4,47.6 13,47.6 L15.5,47.6 C16.1,47.6 16.5,47.2 16.5,46.6 C16.5,46 16.1,45.6 15.5,45.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M22.2,45.6 L19.7,45.6 C19.1,45.6 18.7,46 18.7,46.6 C18.7,47.2 19.1,47.6 19.7,47.6 L22.2,47.6 C22.8,47.6 23.2,47.2 23.2,46.6 C23.2,46 22.8,45.6 22.2,45.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M28.9,45.6 L26.4,45.6 C25.8,45.6 25.4,46 25.4,46.6 C25.4,47.2 25.8,47.6 26.4,47.6 L28.9,47.6 C29.5,47.6 29.9,47.2 29.9,46.6 C29.9,46 29.4,45.6 28.9,45.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M35.6,45.6 L33,45.6 C32.4,45.6 32,46 32,46.6 C32,47.2 32.4,47.6 33,47.6 L35.5,47.6 C36.1,47.6 36.5,47.2 36.5,46.6 C36.5,46 36.1,45.6 35.6,45.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M42.3,45.6 L39.8,45.6 C39.2,45.6 38.8,46 38.8,46.6 C38.8,47.2 39.2,47.6 39.8,47.6 L42.3,47.6 C42.9,47.6 43.3,47.2 43.3,46.6 C43.3,46 42.8,45.6 42.3,45.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M46.4,47.6 L48.9,47.6 C49.5,47.6 49.9,47.2 49.9,46.6 C49.9,46 49.5,45.6 48.9,45.6 L46.4,45.6 C45.8,45.6 45.4,46 45.4,46.6 C45.4,47.2 45.9,47.6 46.4,47.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M53.1,47.6 L55.6,47.6 C56.2,47.6 56.6,47.2 56.6,46.6 C56.6,46 56.2,45.6 55.6,45.6 L53.1,45.6 C52.5,45.6 52.1,46 52.1,46.6 C52.1,47.2 52.5,47.6 53.1,47.6 Z",
  id: "Shape"
}), React.createElement("path", {
  d: "M59.8,47.6 L62.3,47.6 C62.9,47.6 63.3,47.2 63.3,46.6 C63.3,46 62.9,45.6 62.3,45.6 L59.8,45.6 C59.2,45.6 58.8,46 58.8,46.6 C58.8,47.2 59.2,47.6 59.8,47.6 Z",
  id: "Shape"
})));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "73px",
    height: "54px",
    viewBox: "0 0 73 54",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/wallet.14174bae.svg";
export { SvgComponent as ReactComponent };